<script lang="ts">
  import { signupStore } from "$app/signupstore.svelte"
  let activeClass = "bg-white text-lwp-theme-blue"
</script>

<div
  class="bg-lwp-theme-blue text-gray-200 rounded-full flex py-1 px-2"
  id="period-selector"
>
  <button
    type="button"
    data-name="monthly-billing"
    onclick={() => (signupStore.billingInterval = "month")}
    class={[
      "rounded-full px-4 py-2",
      signupStore.billingInterval === "month" ? activeClass : ""
    ]}
  >
    Monthly billing
  </button>
  <button
    type="button"
    data-name="yearly-billing"
    onclick={() => (signupStore.billingInterval = "year")}
    class={[
      "rounded-full px-4 py-2",
      signupStore.billingInterval === "year" ? activeClass : ""
    ]}
  >
    Yearly billing
  </button>
</div>
